import {
  CanvasElementType,
  CanvasObjectPosition,
  CanvasObjectSize,
  CanvasObjectStyles,
  CanvasTextSettings,
  FontWeight,
  TextAlignment,
} from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

const canvasTextStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
};

export const canvasTextDefaultSettings: CanvasTextSettings = {
  textStyles: {
    'font-weight': FontWeight.Normal,
    'font-size': '16px',
    'font-family': 'Arial',
    'text-align': TextAlignment.Left,
    color: '#000',
  },
  text: '',
};

const canvasTextDefaultSize: CanvasObjectSize = {
  width: 200,
  height: 25,
};

export function getCanvasTextModel(data: { position: CanvasObjectPosition }) {
  return {
    type: CanvasElementType.Text,
    size: canvasTextDefaultSize,
    position: data.position,
    typeSettings: canvasTextDefaultSettings,
    styles: canvasTextStylesDefaultConstant,
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: false,
    },
  };
}

export type CanvasTextModel = VisualizationCanvasElementStoreModel<CanvasElementType.Text>;
